module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/alert-33bb37cd471c2bc4d495727e8da40f81.svg";